import { render, staticRenderFns } from "./EntityCommissions.vue?vue&type=template&id=2c4cfd5a&lang=pug"
import script from "./EntityCommissions.vue?vue&type=script&lang=js"
export * from "./EntityCommissions.vue?vue&type=script&lang=js"
import style0 from "./EntityCommissions.vue?vue&type=style&index=0&id=2c4cfd5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports